import { FormlyFieldConfig } from "@ngx-formly/core";
import { of, startWith, switchMap, tap } from "rxjs";

export const UbicazioneStep: FormlyFieldConfig[] =

     [

        {
            fieldGroupClassName: 'grid sm:grid-cols-1 md:grid-cols-8 gap-4',
            fieldGroup: [
                {
                    "className": 'sm:col-span-1 md:col-span-8',
                    "key": 'jd.mappa1',
                    "type": 'g-map-type',
                    "props": {
                        "label": 'Mappa',
                    },
                    expressions:{
                        hide:"model.stato_id!='compilazione'"
                    }
                },
                {
                    "className": 'sm:col-span-1 md:col-span-4',
                    "key": 'jd.via',
                    "type":'mat-autocomplete',
                    "props": {
                        "label": 'VIA',
                        "required": true,
                    },
                    "validation": {
                        "show": true,
                    },
                    validators:{
                        validation:['AutocompleteMatch'],
                    }     ,
                    "expressions": {
                        "props.filter": "formState.filterVie",
                    }
                },
                {
                    "className": 'sm:col-span-1 md:col-span-2',
                    "key": 'jd.civico',
                    "type":'mat-autocomplete',
                    "props": {
                        "label": "CIVICO",
                        "required": true,
                        "freevalues": true, //se ci possimo mettere anche un valore non in elenco
                        "optionSelected": (x: any, field: FormlyFieldConfig) => {
                            const value = field.formControl.value;
                            //aggiorna la posizione sul cambio del civico
                            if (value.lat && value.lng) {
                                field.parent.get('lat').formControl.setValue(value.lat);
                                field.parent.get('lng').formControl.setValue(value.lng);
                                field.options.formState.mapService.setPosition({ lat: value.lat, lng: value.lng })
                            }
                        }
                    },
                    hooks: {
                        onInit: (field) => {
                            const vieControl = field.parent.get('jd.via').formControl;
                            //Aggiorna l'elenco sul cambio della via
                            vieControl.valueChanges.pipe(
                                startWith(vieControl.value),
                                tap(() => {
                                    // Quando cambia la via, bisogna forzare un aggiornamento del campo civico
                                   // field.formControl.setValue('',{emitEvent:false});
                                //    console.log(field.formControl.value)
                                //    console.log(vieControl.value)
                                //    console.log(typeof field.formControl.value)
                                   if (typeof field.formControl.value == 'object' && field.formControl.value.codvia !== vieControl.value?.key) {
                                        field.formControl.setValue('',{emitEvent:true});
                                   }
                                }),
                                switchMap((value) => {
                                    field.props.filter = (term: string = '') => field.options.formState.filterCivici(value?.key, term)
                                    return of(value)
                                })
                            ).subscribe()

                        }
                    }
                },
                {
                    "className": 'sm:col-span-1 md:col-span-1',
                    "key": 'lat',
                    "type":'mat-input',
                    "props": {
                        "label": "LAT",
                        "readonly": true
                    },
                },
                {
                    "className": 'sm:col-span-1 md:col-span-1',
                    "key": 'lng',
                    "type":'mat-input',
                    "props": {
                        "label": "LNG",
                        "readonly": true
                    },
                },
            ]
        },

        {
            "key": 'geom'
        },
        {
            "key": 'jd.note',
            "defaultValue": '',
            "type":'mat-textarea',
            "props": {
                "label": "NOTE",
                "autosize": true,
                "autosizeMaxRows": 8,
                "autosizeMinRows": 2
            },
        },
    ]

